export const LeopardStrip = ({ className = "h-8 sm:h-12" }) => (
  <div
    aria-hidden="true"
    data-testid="leopard-strip"
    className={`w-full bg-cover bg-center ${className}`}
    style={{ backgroundImage: "url(/assets/leopard.jpg)" }}
  />
);

export const LeopardFrame = ({ children, className = "" }) => (
  <div className={`relative ${className}`}>
    <div
      aria-hidden="true"
      className="absolute -inset-3 bg-cover bg-center sm:-inset-4"
      style={{ backgroundImage: "url(/assets/leopard.jpg)" }}
    />
    <div className="relative">{children}</div>
  </div>
);
